import React from 'react';
import { TypeProgressBar } from '../index';
import './style.scss';

export const TypeBlock = () => (
  <div className="type_block">
    <h2 className="type_block_subtitle">Type</h2>
    <div className="type_block_row">
      <TypeProgressBar percent={20} title="Carriers" />
      <TypeProgressBar percent={0} title="Resellers" />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/TypeBlock/index.js